/* 
Storage Key Constants

  This mainly exists for the Expo GO app.
    When switching between Dev / & Production builds, we do not want stored data to overlap
*/

export interface StorageKeys {
  appsflyerInstallParams: string;
  redirectPath: string;
  redirectUrl: string;
  pendingDestination: string;
  authCodeInput: string;
  accessToken: string;
  oldAccessToken: string;
  workspace: string;
  accountFilter: string;
  accountTypeFilter: string;
  accountOrderBy: string;
  activityFilter: string;
  assetActivityFilter: string;
  accountActivityFilter: string;
  assetFilter: string;
  assetMediaFilter: string;
  routineFilter: string;
  routineOrderBy: string;
  email: string;
  assetOrderBy: string;
  groupFilter: string;
  groupOrderBy: string;
  fileFilter: string;
  fileOrderBy: string;
  location: string;
  assetsScrollData: string;
  newRegister: string;
  productFilter: string;
  productOrderBy: string;
  addOnFilter: string;
  addOnOrderBy: string;
  workspaceFilter: string;
  workspaceOrderBy: string;
  deepLinkData: string;
  anonymousIssueIds: string;
  anonymousRoutineIds: string;
}

export type StorageKeysHook = () => StorageKeys;

export const useStorageKeys = (): StorageKeys => {
  if (!process.env.EXPO_PUBLIC_PREFIX) {
    throw new Error(
      'EXPO_PUBLIC_PREFIX must be set in the environment variables.'
    );
  }
  const prefix = process.env.EXPO_PUBLIC_PREFIX;

  return {
    appsflyerInstallParams: `${prefix}_appsflyerInstallParams`,
    redirectPath: `${prefix}_redirectPath`,
    redirectUrl: `${prefix}_redirectUrl`,
    // Where the visitor was headed before being sent to sign in. Separate from
    // `redirectPath` because `onAccessTokenReceived` clears that one the moment
    // a token arrives, which is before the app has finished landing anywhere.
    pendingDestination: `${prefix}_pendingDestination`,
    accessToken: `${prefix}_accessToken`,
    oldAccessToken: `${prefix}_oldAccessToken`,
    authCodeInput: `${prefix}_authCodeInput`,
    workspace: `${prefix}_workspace`,
    accountFilter: `${prefix}_accountFilter`,
    accountTypeFilter: `${prefix}_accountTypeFilter`,
    accountOrderBy: `${prefix}_accountOrderBy`,
    activityFilter: `${prefix}_activityFilter`,
    assetActivityFilter: `${prefix}_assetActivityFilter`,
    accountActivityFilter: `${prefix}_accountActivityFilter`,
    assetFilter: `${prefix}_assetFilter`,
    assetMediaFilter: `${prefix}_assetMediaFilter`,
    assetOrderBy: `${prefix}_assetOrderBy`,
    routineFilter: `${prefix}_routineFilter`,
    routineOrderBy: `${prefix}_routineOrderBy`,
    groupFilter: `${prefix}_groupFilter`,
    groupOrderBy: `${prefix}_groupOrderBy`,
    fileFilter: `${prefix}_fileFilter`,
    fileOrderBy: `${prefix}_fileOrderBy`,
    email: `${prefix}_email`,
    location: `${prefix}_location`,
    assetsScrollData: `${prefix}_assetsScrollData`,
    newRegister: `${prefix}_newRegister`,
    productFilter: `${prefix}_productFilter`,
    productOrderBy: `${prefix}_productOrderBy`,
    addOnFilter: `${prefix}_addOnFilter`,
    addOnOrderBy: `${prefix}_addOnOrderBy`,
    workspaceFilter: `${prefix}_workspaceFilter`,
    workspaceOrderBy: `${prefix}_workspaceOrderBy`,
    deepLinkData: `${prefix}_deepLinkData`,
    anonymousIssueIds: `${prefix}_anonymousIssueIds`,
    anonymousRoutineIds: `${prefix}_anonymousRoutineIds`,
  };
};
